<template>
    <div class="notifications">
        <transition-group mode="out-in" :enter-active-class="enterTransitionClass" :leave-active-class="exitTransitionClass" appear>
            <notification
                v-for="notification in notifications"
                v-bind="notification"
                :clickHandler="notification.onClick"
                :key="notification.timestamp.getTime()"
                @close="removeNotification"
            >
            </notification>
        </transition-group>
    </div>
</template>
<script>
import Notification from './Notification.vue';
import TransitionAnimationMixin from '../components/TransitionAnimationMixin';

export default {
    mixins     : [TransitionAnimationMixin],
    components : {
        Notification
    },
    props : {
        overlap : { type : Boolean, default : false }
    },
    data () {
        return {
            notifications : this.$notifications.state
        };
    },
    methods : {
        removeNotification (timestamp) {
            this.$notifications.removeNotification(timestamp);
        }
    },
    created () {
        this.$notifications.settings.overlap = this.overlap;
    },
    watch : {
        overlap : function (newVal) {
            this.$notifications.settings.overlap = newVal;
        }
    }
};
</script>
